export const ADD_LESSON = 'EMPTY_STATE.ADD_LESSON';
